<template>
  <div class="coupon-info">
      
    <van-skeleton v-if="!firstloading" title :row="5" style="background-color:#fff;padding:20px" />
    <template v-else-if="item">
        
    <div class="coupon-tj">
      <div class="coupon-tj-item">
        <div class="title">企业微信新增好友</div>
        <div class="text">{{item.qywx_count}}人</div>
      </div>
      <!-- <div class="coupon-tj-item">
        <div class="title">服务号新增粉丝</div>
        <div class="text">{{item.wxfwh_count}}人</div>
      </div> -->

        <div class="coupon-tj-item" v-if="!(item.coupon_type && item.coupon_type ==2)">
        <div class="title">参与赠礼活动人数</div>
        <div class="text">{{item.wxfwh_count}}人</div>
      </div>
    </div>

    <div class="coupon-row">
      <div class="xl-title">参与活动二维码</div>
      <div class="sm-title">老用户扫码即可生成自己的专属赠礼海报</div>
      <img :src="item.qrcodeurl" alt class="qrcode" />
    </div>
    <div class="coupon-row">
      <div class="xl-title">影响力排行榜链接</div>
      <div class="field">
        <input type="text"  :value="item.rushurl"/>
        <button 
                v-clipboard:copy="item.rushurl"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError">点击复制</button>
      </div>
    </div>
     <div class="coupon-row">
      <div class="xl-title">分享海报链接</div>
      <div class="field">
        <input type="text" :value="item.posterurl" />
        <button
                v-clipboard:copy="item.posterurl"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError">点击复制</button>
      </div>
    </div>
    <div class="coupon-row">
      <div class="xl-title">查看个人赠礼明细链接</div>
      <div class="field">
        <input type="text" :value="item.myrushurl" />
        <button
                v-clipboard:copy="item.myrushurl"
                v-clipboard:success="onCopy"
                v-clipboard:error="onCopyError">点击复制</button>
      </div>
    </div>
    <div class="coupon-row" style="margin-top:20px;">
      <van-button type="primary" icon="edit" @click="edit" >编辑活动</van-button>
    </div>
    <!-- <div class="coupon-row">
          <div class="xl-title">影响力排行</div>
         
    </div>-->
    </template>

    <div v-else>系统异常，请稍后重试</div>
     <div class="coupon-row">
        <van-tabs>
            <van-tab title="裂变排行榜">
            <div class="rush-list">
              <van-list
                v-model="data.loading"
                :finished="data.finished"
                :finished-text="
                  data.datas && data.datas.length > 0
                    ? '没有更多了'
                    : '还没有排行数据'
                "
                @load="onLoad"
              >
                <div
                  class="rush-user"
                  v-for="(item, index) in data.datas"
                  :key="index"
                  @click="userClick(item.user_id)"
                >
                  <div class="ranking-hig" v-if="index + 1 <= 3">
                    <img
                      src="../../../static/images/icon/rush1.png"
                      alt
                      v-if="index + 1 == 1"
                    />
                    <img
                      src="../../../static/images/icon/rush2.png"
                      alt
                      v-if="index + 1 == 2"
                    />
                    <img
                      src="../../../static/images/icon/rush3.png"
                      alt
                      v-if="index + 1 == 3"
                    />
                  </div>
                  <div class="ranking" v-else>{{ index + 1 }}</div>
                  <img :src="item.AvatarUrl" alt class="userhead" />
                  <div class="nickname">{{ item.NickName }}</div>
                  <div class="userrecount">送出{{ item.re_user_count }}份</div>
                </div>
              </van-list>
            </div>
          </van-tab>
        </van-tabs>
      </div>
  </div>
</template>
<script>
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

export default {
  name: "app",
  data() {
    return {
      firstloading: false,
      item:null,
        data: {
        page: 1,
        channeltype: 0,
        datas: [],
        loading: false,
        finished: false,
      },
    };
  },
  //监听路由的路径，可以通过不同的路径去选择不同的切换效果
  watch: {},
  methods: {
     edit(){
       var t = this;
      t.$router.replace({
        path: "/mcoupon/detail",
        query: { id: t.item.coupon_id},
      });

    
    },
    onCopy() {
      this.$Toast("复制成功");
    },
    onCopyError() {
      this.$Toast("当前浏览器不支持复制，请手动复制");
    },
    getdetail(id) {
      var t = this;
      t.$http
        .get("/Coupon/GetCouponTJInfo", { couponid: id }, 2)
        .then(res => {
          t.firstloading = true;
          if (res.resultState == 1) {
           t.item = res.Data;
           console.log("打印item", t.item );
          }
        })
        .catch(error => {
          t.firstloading = true;
        });
    },
    // 用户点击
    userClick(id){
      console.log(id);
      this.$router.push(`/mcoupon/UserList?id=${id}&no=${this.item.coupon_no}`)
    },

    // 加载
     onLoad() {
      var t = this;
      console.log("onLoad", t.data.page);
      t.data.loading = true;
      t.$http
        .get(
          "/Coupon/RushList",
          {
            coupon_id: t.$route.query.id,
            pageindex: t.data.page,
            pagesize: 15,
          },
          2
        )
        .then((res) => {
          console.log("打印res222222",res);
          t.data.loading = false;
          if (res.resultState == 1) {
            t.data.datas = t.data.datas.concat(res.Data.datas);
            t.data.page += 1;
            if (res.Data.datas.length < 15) t.data.finished = true;
          } else {
            t.data.finished = true;
            Toast(res.errorMsg);
          }
          console.log("t.data.finished", t.data.finished);
        })
        .catch((error) => {});
    },
  },
  components: {},
  created(){
    this.getdetail(this.$route.query.id);
    this.onLoad()
    console.log("打印data",this.data);
  },
  mounted() {
  }
};
</script>


<style lang="scss">
@import "../../../static/scss/var";
.coupon-info {
  box-sizing: border-box;
  background: #fff;
  padding: 20px 20px;
  min-height: 260vw;
  .coupon-tj {
      @include flex;
      width: 100%;
      border-bottom:1px solid #eee;
      padding-bottom:15px;
      .coupon-tj-item{margin-right: 15px;@include flex_1;
      .title{
      color: $vm_fontcolor_minor2; line-height: 40px; font-size: 14px;}
      }
      .text{ }
      .coupon-tj-item:last-child{ margin-right: 0;}
  }
  .coupon-row {
    .xl-title {
      line-height: 50px;
    }
    .sm-title {
      font-size: 14px;
      color: $vm_fontcolor_minor2;
      margin-top: -10px;
    }
    img.qrcode {
      border: 1px solid #efefef;
      margin-top: 10px;
      width: 70%;
      max-width: 350px;
    }
    .field {
      width: 100%;
      padding: 5px 10px;
      border: 1px solid #eee;
      box-sizing: border-box;
      @include flex;
      @include align_items_center;
      input {
        @include flex_1;
        border: 0;
      }
      button {
          margin-left:10px;
        border: 0;
        background: $vm_bg_main;
        color: #fff;
        font-size: 14px;
        line-height: 28px;
        padding: 0 10px;
      }
    }
  }
}
.rush-list {
  background-color: #fff;
  overflow: hidden;
  padding: vw(30) 0;
  margin-bottom: vw(120);
  box-sizing: border-box;
  .rush-user {
    margin-bottom: vw(45);
    @include flex;
    @include align_items_center;
    width: 100%;
    .ranking {
      width: vw(90);
      text-align: center;
      font-size: vw(44);
      color: $vm_bg_main;
    }
    .ranking-hig {
      width: vw(90);
      text-align: center;
      img {
        width: vw(56);
      }
    }
    .userhead {
      width: vw(80);
      height: vw(80);
      border-radius: vw(10);
    }
    .nickname {
      @include flex_1;
      font-size: vw(28);
      margin: 0 vw(20);
      color: $vm_fontcolor_main;
    }
    .userrecount {
      width: vw(220);
      color: $vm_fontcolor_minor2;
      text-align: right;
      margin-right: vw(30);
    }
  }
}

.giftlist {
  .giftitem {
    @include flex;
    @include align_items_center;
    border-bottom: 1px solid #f6f6f6;
    padding: vw(15) 0;
    .gifticon {
      width: vw(70);
      height: vw(70);
    }
    .giftiteminfo {
      @include flex_1;
      margin-left: vw(20);
      .xltitle {
      }
      .desc {
        color: #888;
        font-size: 12px;
      }
    }
    .btnaction {
      color: #1989fa;
      font-size: 14px;
    }
  }
}
</style>
